<template>
  <div>
    <!--Sub Header Start-->

    <section class="wf100 subheader" style="background: var(--success); ">
      <div class="container">
        <h2>خطوات تأسيس منظمة</h2>
        <ul>
          <li>
            <router-link to="/" href="#">الرئيسية</router-link>
          </li>
          <li>خطوات تأسيس منظمة</li>
        </ul>
      </div>
    </section>

    <!--Sub Header End-->
    <!--Main Content Start-->
    <div class="main-content">
      <div class="container py-1">
        <div class="d-flex justify-content-between mb-1 w-100 align-items-center gap-1 steps-tabs">
          <h6>
            <span>رسوم الخدمة : </span>
            <span> 50 ل.س </span>
          </h6>
          <!-- <h6>
            <span>مدة الخدمة : </span>
            <span> 30 يوم </span>
          </h6> -->
          <b-button variant="success" size="md" class="d-flex align-items-center" style="gap: 4px"
            @click="$router.push('/signup')">
            <span> بدء الخدمة </span>
            <feather-icon icon="ChevronsLeftIcon" />
          </b-button>
        </div>
        <hr />
        <b-tabs vertical class="steps-tabs">
          <b-tab size="lg">
            <template #title>
              <div style="
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                ">
                <div class="my-50">
                  <feather-icon size="30" icon="InfoIcon"> </feather-icon>
                </div>

                <span>معلومات الخدمة</span>
              </div>
            </template>
            <b-card-text class="p-1">
              <h6 class="mb-25">وصف الخدمة</h6>
              <p>
                يمكن من خلال منصة تشارك تقديم طلب خاص بتأسيس
                منظمة غير حكومية والإطلاع على المتطلبات و استكمال كافة الأوراق الثبوتية
                مما يسهل الإجراءات و يختصر الكثير من الوقت.
              </p>

              <h6 class="mb-25">الجهة المقدمة للخدمة:</h6>
              <p>وزارة الشؤون الاجتماعية والعمل</p>
              <h6 class="mb-25">الجمهور المستفيد من الخدمة:</h6>
              <p>
                كافة مواطنين الجمهورية العربية السورية والراغبين بتأسيس منظمات
                أو جمعيات أو اتحادات ممن لا تقل أعمارهم عن (18) ثمانية عشر عاماً ميلادياً وتنطبق عليهم شروط التأسيس
              </p>
              <h6 class="mb-25">الوثائق المطلوبة:</h6>
              <p>
              <ul>
                <li>
                  طلب إشهار المنظمة.
                </li>
                <li>
                  قرار تعيين مندوب الجمعية لإتمام إجراءات الشهر .
                </li>
                <li>
                  محضر انتخاب مجلس الإدارة الأولى للجمعية موقع من المؤسسين / 4 / نسخ .
                </li>
                <li>
                  أربع نسخ من القائمة المتضمنة أسماء المؤسسين وجنسيتهم وسنهم ومهنتهم ومحل إقامتهم ومكان العمل ، عنوان الإقامة الدائم والمؤقت ، إن وجد المؤهل العلمي ، رقم الهاتف موقع من المؤسسين .
                </li>
                <li>
                  أربع نسخ من عقد تأسيس الجمعية موقع من المؤسسين .
                </li>

                <li>
                  أربع نسخ من نظام الجمعية موقع من المؤسسين .
                </li>
                <li>
                  أربع نسخ من نشرة استعلامات + صورة شخصية + صورة هوية .
                </li>
                <li>
                  عقد إيجار بمقر للجمعية أو سند ملكية لمقر الجمعية
                </li>
                <span class="text-warning">
                  ملاحظة : كل نسخة توضع في مصنف على حدا .
                </span>
              </ul>
              </p>
            </b-card-text>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="v-tab">
                <div class="my-50">
                  <feather-icon size="30" icon="CheckSquareIcon">
                  </feather-icon>
                </div>

                <span>الإجراءات</span>
              </div>
            </template>
            <b-card-text>
              <app-timeline>
                <app-timeline-item title="التقدم بطلب تأسيس"
                  subtitle="يتضمن كامل المعلومات المطلوبة آنفاً ، عبر بوابة المنظمات غير الحكومية" variant="success"
                  :customPoint="true">
                  <template #point>
                    1
                  </template>
                </app-timeline-item>

                <app-timeline-item title="دراسة الطلب من قبل الجهة الحكومية المختصة"
                  subtitle="بحسب الصلاحيات الممنوحة ضمن سير المعاملة" variant="success" :customPoint="true">
                  <template #point>
                    2
                  </template>
                </app-timeline-item>

                <app-timeline-item title="الموافقة على طلب التأسيس بعد إجراء التعديلات اللازمة على الطلب"
                  variant="success" subtitle="." :customPoint="true">
                  <template #point>
                    3
                  </template>
                </app-timeline-item>

                <app-timeline-item variant="success" title="إعداد وثائق التأسيس" subtitle="المتضمنة بشكل خاص : النظام الداخلي , نشرات استعلام الأعضاء المؤسسين و أعضاء مجلس الأمناء حيث يمكن أن يؤسس شخص طبيعي أواعتباري مؤسسة،
ويعين مجلس أمناء مستقل عنه. , وثيقة إشغال المقر." :customPoint="true">
                  <template #point>
                    4
                  </template>

                </app-timeline-item>

                <app-timeline-item title="عبر بوابة المنظمات غير الحكومية"
                  subtitle="التقدم بالوثائق للجهة الحكومية المختصة" variant="success" :customPoint="true">
                  <template #point>
                    5
                  </template>
                </app-timeline-item>

                <app-timeline-item title="عبر بوابة المنظمات غير الحكومية"
                  subtitle="التقدم بالوثائق للجهة الحكومية المختصة" variant="success" :customPoint="true">
                  <template #point>
                    6
                  </template>
                  <h6 class="mb-25">
                    مراسلة الجهات الحكومية الأخرى من قبل الجهة الحكومية المختصة
                  </h6>
                  <p>
                  <ul>
                    <li>
                      شعبة الأمن السياسي بالنسبة للأعضاء
                    </li>
                    <li>
                      محافظة المقر ( بالنسبة لحاجة المحافظة لخدمات المنظمة غير الحكومية ) </li>

                    <li>
                      الوزارة الفنية المختصة بعمل المنظمة غيرالحكومية (وزارة الصحة- وزارة التربية- وزارة الثقافة)
                    </li>
                  </ul>
                  </p>
                </app-timeline-item>
                <app-timeline-item title="إصدار قرار التأسيس أو رفض التأسيس من قبل وزير الشؤون الاجتماعية والعمل"
                  subtitle="حسب نتيجة رأي الجهات الحكومية
الشريكة ورأي وزارة الشؤون الاجتماعية والعمل" variant="success" :customPoint="true">
                  <template #point>
                    7
                  </template>

                </app-timeline-item>
              </app-timeline>
            </b-card-text>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="v-tab">
                <div class="my-50">
                  <feather-icon size="30" icon="BookOpenIcon"> </feather-icon>
                </div>

                <span>الأحكام و الشروط</span>
              </div>
            </template>
            <b-card-text>

              <h6>
                معايير اختيار الاسم
                :</h6>
              <p>

              <ul>

                <li>
                  عدم وجود اسم مشابه سابق ضمن الجمعيات والمؤسسات المشهرة، أو قيد التأسيس السابقة لطلب التأسيس.
                </li>
                <li>
                  خلو االاسم المراد اختياره من أي طابع ديني، أو سياسي، أو عنصري
                </li>
                <li>
                  أن يكون الاسم ذو دلالة متلائماً مع أهداف الجمعية أو المؤسسة المراد تأسيسها, ومتوافقاً مع تصنيف مجال
                  العمل
                </li>
                <li>
                  في حال الرغبة في اختيار أسماء أجنبية، يجب أن يرفق
                  الطلب بترجمة محلفة للاسم، وتوضيح مدلولاته، علما
                  ان الاسم المعتمد سيكون هو االاسم باللغة العربية.
                </li>
              </ul>
              </p>
              <h6>
                معايير النطاق الجغرافي
                :</h6>
              <ul>
                <li>
                  الجمعيات والمؤسسات التي تحمل تصنيف (التنمية والإسكان أو البيئة أو القانون والدفاع والحقوق أو الثقافة
                  والرياضة والتسلية والفنون).
                </li>

                <li>
                  الجمعيات والمؤسسات العلمية
                </li>
                <li>
                  الجمعيات والمؤسسات التي تُعنى بالأمراض المزمنة (سرطان- سكري- ......).
                </li>
                <li>
                  الجمعيات والمؤسسات التي تعنى بالأمراض المزمنة
                </li>
              </ul>
              <p>
                ويمكن أن يتم توسيع النشاط لمحافظتين أو ثلاثة كحد أقصى بعد الحصول على موافقة المكاتب التنفيذية لتلك
                المحافظات من قبل الوزارة، وبعد التأكد من إمكانيات الأعضاء المؤسسين وحاجة المحافظات لتصنيف وخدمات الجمعية
                أو المؤسسة قيد التأسيس.</p>
              <h6>
                معايير الموافقة على الأعضاء المؤسسين: </h6>

              <ul>
                <li>
                  يكون الحد الأدنى لعدد الأعضاء المؤسسين في الجمعية هو 11 عضو مؤسس، على أن يكون مجلس الإدارة مؤلف من 5
                  أو 7 أو 9 أو 11 عضو.
                  أما بالنسبة للمؤسسة، فيمكن أن يؤسسها شخص طبيعي أو اعتباري واحد أو أكثر، على أن يتم اختيار مجلس أمناء
                  مؤلف من 5 أو 7 أو 9 أمناء.

                </li>
                <li>
                  يجب أن تتوافق الأهداف المطروحة مع مؤهلات الأعضاء المؤسسين، وأن تتضمن مجموعة الأعضاء المؤسسين عضوين كحد
                  أدنى يمتلكان المؤهلات العلمية المتناسبة مع تصنيف الجمعية أو المؤسسة قيد التأسيس ومجال عملها، أو أن يتم
                  التعهد من قبل الأعضاء المؤسسين بتأمين الكوادر الاختصاصية اللازمة لعمل الجمعية أو المؤسسة، بما يضمن
                  استدامة وجودة الخدمات المقدمة للمستفيدين.
                </li>
                <li>
                  يجب ألّا يتواجد أكثر من عضو واحد من عائلة واحدة في تشكيلة مجلس الإدارة، منعاً من تحويل الجمعيات
                  الأهلية لجمعيات عائلية، وفي حال كان التأسيس ضمن قرى يرتبط أغلب سكانها بعلاقات قربى، يمنع تواجد أكثر من
                  عضوين في مجلس الإدارة من عائلة واحدة، إضافة لعدم شغل القريبين الاثنين المتواجدين في مجلس الإدارة سوية
                  للمناصب التي تخولهما تحريك الحسابات المصرفية (رئيس مجلس الإدارة- نائب رئيس مجلس الإدارة- أمين
                  الصندوق).
                </li>
                <li>
                  في حال كان أحد الأشخاص المراد اشتراكه بتأسيس الجمعية أو المؤسسة، هو شخص اعتباري (شركة تجارية، شركة
                  مدنية، هيئة، .....)، يجب ارفاق ما يثبت الوضع القانوني للشخص الاعتباري، إضافة إلى قرار صريح من صاحب
                  الصلاحية في الاشتراك بتأسيس الجمعية أو المؤسسة.
                </li>
                <li>
                  في حال كان أحد الأشخاص المراد اشتراكه بتأسيس الجمعية أو المؤسسة، هو شخص غير سوري، يجب أن يكون له مقر
                  إقامة دائم في الجمهورية العربية السورية، مع ارفاق سند إقامة مصدق أصولاً.
                </li>
                <li>
                  عدم اشتراك رجال الدين في تأسيس الجمعيات أو المؤسسات، منعاً من تأثير مهامهم في العمل الأهلي، تطبيقاً
                  لأحكام قانون الجمعيات والمؤسسات الخاصة رقم 93 لعام 1958.
                </li>
                <li>
                  عدم اشتراك العسكريين وعناصر وضباط الشرطة بأي صفة كانت في تأسيس الجمعيات والمؤسسات الخاصة، عملاً بأنظمة
                  الخدمة.
                </li>
              </ul>
              <h6>
                معايير اختيار الأهداف:
              </h6>
              <ul>
                <li>
                  أن تكون الأهداف محصورة بتصنيف أساسي واحد فقط بالنسبة للجمعيات، ومجالات التخصص المرتبطة بهذا التصنيف
                  حصراً، أما بالنسبة للمؤسسات الخاصة فيمكن اختيار حتى تصنيفين أساسيين، وفقاً لطبيعة عمل المؤسسة وقدراتها
                  الفنية والمالية.
                </li>
                <li>
                  أن تكون الأهداف مصاغة بطريقة عملية، بعيداً عن الانشائية، وتتصف بالوضوح والمنطقية، القابلية للتحقيق
                  والقياس، وأن تتم صياغتها بشكل بعيد المدى، بالاستئناس باستمارة التصنيف المعياري المعتمد، دون نسخ
                  واستخدام عبارات الاستمارة حرفياً.
                </li>
                <li>
                  ألّا يتجاوز عدد بنود الأهداف الأربعة بنود كحد أقصى.
                </li>
                <li>
                  عدم الخلط في صياغة الأهداف بين الهدف ووسائل تحقيقه (حيث تعتبر إقامة المحاضرات والندوات- اصدار
                  المنشورات- التعاون مع الجمعيات أو الوزارات ........ وسائل تحقيق أهداف).
                </li>
              </ul>
            </b-card-text>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="v-tab">
                <div class="my-50">
                  <feather-icon size="30" icon="BookIcon"> </feather-icon>
                </div>

                <span>الفوارق القانونية</span>
              </div>
            </template>
            <b-card-text>
              <table class="w-100 terms-table">
                <thead>
                  <tr>
                    <th>
                      الموضوع
                    </th>
                    <th>الجمعية</th>
                    <th>المؤسسة</th>
                    <th>الاتحاد</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      التأسيس
                    </td>
                    <td>تتأسس الجمعية عن طريق اجتماع عدد من الأشخاص بهدف العمل في المجال الأهلي، بموجب طلب تأسيس
                    </td>
                    <td>تتأسس المؤسسة عن طريق تخصيص مال معين بهدف العمل في المجال الأهلي، بموجب سند تأسيس (ويمكن أن يكون
                      سند التأسيس عن طريق وصية)
                    </td>
                    <td>يتأسس الاتحاد عن طريق اجتماع عدد من الجمعيات أو المؤسسات المشهرة بهدف العمل في المجال الأهلي،
                      بموجب طلب تأسيس
                    </td>
                  </tr>
                  <tr>
                    <td>
                      عدد الاعضاء المؤسسين </td>
                    <td>
                      11 عضو مؤسس كحد أدنى
                    </td>
                    <td>
                      يمكن أن يؤسسها شخص طبيعي
                      أواعتباري واحد أوأكثر
                    </td>
                    <td>
                      7 جمعيات أو مؤسسات كحد أدنى
                    </td>
                  </tr>
                  <tr>
                    <td> مجال التصنيف
                    </td>
                    <td>
                      تصنيف أساسي واحد فقط من
                      التصنيف المعياري المعتمد
                    </td>
                    <td>
                      تصنيفين أساسيين كحد أقصى،
                      وفقاً لطبيعة عمل المؤسسة وقدراتها الفنية والمالية
                    </td>
                    <td>
                      يتحدد بحسب قرار تأسيس
                      الاتحاد
                    </td>

                  </tr>
                  <tr>
                    <td>
                      الهيكل الإداري
                      والتنظيمي
                    </td>
                    <td>- هيئة عامة مكونة من المنتسبين للجمعية
                      <br>
                      - مجلس ادارة تنتخبه الهيئة العامة لمدة عامين

                    </td>

                    <td>مجلس أمناء يتم تعيينه أو انتخابه وتحديد مدة ولايته بحسب النظام الأساسي لكل مؤسسة (لا يوجد هيئة
                      عامة للمؤسسة)، يعاون مجلس الأمناء جهاز تنفيذي
                    </td>
                    <td>- هيئة عامة مكونة من الجمعيات أو المؤسسات المنتسبة للاتحاد.
                      <br>
                      - مجلس ادارة تنتخبه الهيئة العامة لمدة عامين

                    </td>

                  </tr>
                  <tr>
                    <td>التبرعات</td>
                    <td>يحق للجمعيةالتصدي للجمهور
                      بهدف جمع التبرعات، اضافة الى
                      تلقي التبرعات بشكل مباشر</td>
                    <td>لا يحق للمؤسسة التصدي للجمهور بهدف جمع التبرعات، وهذا لا يمنعها من تلقي التبرعات دون التصدي
                      للجمهور
                    </td>
                    <td>يحق للاتحاد التصدي للجمهور بهدف جمع التبرعات، اضافة الى تلقي التبرعات بشكل مباشر
                    </td>

                  </tr>
                  <tr>
                    <td>الاعفاءات</td>
                    <td>
                      تستفيد من الاعفاءات الواردة في القانون 22 لعام 1974، وتستفيد من الضرائب الكمالية إذا حملت صفة
                      النفع العام، وذلك بموجب المرسوم 55 لعام 2007
                    </td>
                    <td>لا تستفيد من الاعفاءات إلا في حال اعتبارها ذات نفع عام، فتستفيد عندها من الاعفاءات الواردة في
                      المرسوم 55 لعام 2007
                    </td>
                    <td>يستفيد من الاعفاءات الواردة في القانون 22 لعام 1974، وتستفيد من الإعفاء من الضرائب الكمالية إذا
                      حملت صفة النفع العام، وذلك بموجب المرسوم 55 لعام 2007 </td>

                  </tr>
                </tbody>
              </table>
            </b-card-text>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="v-tab">
                <div class="my-50">
                  <feather-icon size="30" icon="HelpCircleIcon"> </feather-icon>
                </div>

                <span>المساعدة</span>
              </div>
            </template>
            <b-card-text>
              <app-collapse id="faq-payment-qna" accordion type="margin" class="mt-2">
                <app-collapse-item v-for="(data, index) in qandA" :key="index" :title="data.question">
                  {{ data.answer }}
                </app-collapse-item>
              </app-collapse>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BTabs, BTab, BCardText, BButton } from "bootstrap-vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import AppTimeline from "@/@core/components/app-timeline/AppTimeline.vue";
export default {
  components: {
    BCardText,
    BButton,
    BTabs,
    BTab,
    AppTimelineItem,
    AppTimeline,
    AppCollapse,
    AppCollapseItem
  },

  data() {
    return {
      qandA: [
        {
          question: 'كيف يمكنني تأسيس منظمة ؟',
          answer: 'التقدم بطلب تأسيس، يتضمن كامل المعلومات المطلوبة آنفا، عبر بوابة المنظمات غير الحكومية'
        },
        {
          question: 'ما هي شروط تأسيس المنظمة؟',
          answer: 'المشاركة بالعمليات المشتركة ما بين الوكالات'
        },
        {
          question: 'ما هو هدف هذه المنظمات؟',
          answer: 'تتميز هذه المنظمات بشكل عام بأن الغرض من وجودها لأهداف أخرى غير ربحية. إذ أن لوجودها عدة أسباب تهدف إلى تحقيق مجموعة واسعة متنوعة من المشاريع والأنشطة. وتتراوح المنظمات غير الحكومية من مجموعات الضغط الصغيرة'
        }
      ]
    }
  }
};
</script>



<style lang="scss">
.terms-table {

  td,
  th {
    border: 1px solid lightgray;
    padding: 5px 10px;
  }
}



.steps-tabs {

  .nav-item,
  .timeline-item {
    list-style-type: none !important;
  }

  h6 {
    margin-bottom: 6px;
  }

  ul {
    li {
      margin-bottom: 10px;
      line-height: 25px;
    }

    li {
      list-style-type: disc;

    }

  }

  .v-tab {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .nav-link.active::after {
    display: none;
  }

  .tab-content {
    border-left: 1px solid lightgray;
  }

  .nav-link {
    transition: all 0.2s ease;
  }

  .nav-link.active {
    background-color: var(--success);
    color: white;
    border-radius: 8px;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }

}
</style>
